<template>
  <v-layout row wrap>
    <form-template @save="onSave" @cancel="onCancel"></form-template>
  </v-layout>
</template>

<script>
  import FormTemplate from './FormTemplate'
  export default {
    components: {
      'form-template': FormTemplate,
    },
    methods: {
      onSave() {
        this.$emit('save')
      },
      onCancel() {
        this.$emit('cancel')
      },
    },
  }
</script>

<style scoped lang="stylus"></style>